import { render, staticRenderFns } from "./easy-pay.vue?vue&type=template&id=0676edf7&scoped=true&"
import script from "./easy-pay.vue?vue&type=script&lang=js&"
export * from "./easy-pay.vue?vue&type=script&lang=js&"
import style0 from "./easy-pay.vue?vue&type=style&index=0&id=0676edf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0676edf7",
  null
  
)

export default component.exports